import { render, staticRenderFns } from "./AddressSelect.vue?vue&type=template&id=1e4a4b29&"
import script from "./AddressSelect.vue?vue&type=script&lang=js&"
export * from "./AddressSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e4a4b29')) {
      api.createRecord('1e4a4b29', component.options)
    } else {
      api.reload('1e4a4b29', component.options)
    }
    module.hot.accept("./AddressSelect.vue?vue&type=template&id=1e4a4b29&", function () {
      api.rerender('1e4a4b29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/addressSelectCheckoutCustom/AddressSelect.vue"
export default component.exports